import { Component } from '@angular/core';
import { Rinvio } from '../../models/rinvio';

declare var removeEmptyObject: any;
@Component({
    selector: 'div [scadenzario-list-rinvii]',
  templateUrl: 'scadenzario-list-rinvii.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export abstract class ScadenzarioListRinviiComponent {
 rinviiList: Rinvio[] = [];
  abstract getRinviiScadenza(): Rinvio[];

  inizializzaMod() {
     this.rinviiList = this.getRinviiScadenza();
  }
}
